export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string
  passing_score: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
    this.passing_score = sumupGroup.passing_score;
  }
}

export class RankResult {
  student_no_character: string
  student_name: string
  addition: string
  isSelected: boolean = false
  score: number
  rank: number
  std_score: number
  passing_text: string

  constructor(rankResult: any){
    this.student_no_character = rankResult.student_no_character;
    this.student_name = rankResult.student_name;
    this.addition = rankResult.addition;
    this.score = rankResult.score;
    this.rank = rankResult.rank;
    this.std_score = rankResult.std_score;
    this.passing_text = rankResult.passing_text;
  }
}

export class AverageResult {
  examinee_count: number
  allot: number
  avg_score: number
  score_rate: number
 
  constructor(averageResult: any){
    this.examinee_count = averageResult.examinee_count;
    this.allot = averageResult.allot;
    this.avg_score = averageResult.avg_score;
    this.score_rate = averageResult.score_rate;
  }
}